module.exports = __webpack_public_path__ + "img/Support-skill-529.6b627c27.png";